import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Table, TableCell, TableContainer, TableRow, TableHead, TableBody, FormControlLabel, Checkbox, FormGroup, CircularProgress, Box} from '@mui/material';
import { useEnumApi } from 'contexts/EnumApiContext';
import { getReportCountGroupByCtgr123AndSubwayLineByQueryString } from 'components/axios/reportAxios';
import CommonExcelDownload from 'components/CommonExcelDownload';

const EquipmentStatusReportDataroomStatusReport = () => {

    const { equipmentCategoryLevel1s } = useEnumApi();
    const { t } = useTranslation();

    const [reports, setReports] = useState([]);
    const [reportParams, setReportParams] = useState([]);
    const [excelDatas, setExcelDatas] = useState([]);
    const excelHeaders = [t('message.common.subtitle.main.category'),t('message.common.subtitle.level2'),t('message.common.subtitle.level3'),
        t('message.common.subtitle.total.count'),t('message.common.subtitle.one.subwayline'),t('message.common.subtitle.two.subwayline')];
    const fileName = t('menu.cmms.report-dataroom.status-report')+"_"+t('message.common.file.name.equipment.status')+"_" + Date.now();

    // 설비현황 보고서 목록
    useEffect(()=>{
        let queryString = "";
        if (reportParams && reportParams.length > 0) {
            for (let i=0;i<reportParams.length;i++) {
                queryString += "equipmentCtgrIds="+reportParams[i];
                if (i < reportParams.length-1) {
                    queryString +="&"
                }
            }
            getReportCountGroupByCtgr123AndSubwayLineByQueryString("?"+queryString).then((data) => {
                if (data) {
                    setReports(data);
                    let datas = [];
                    data && data.forEach(function(column) {
                        let sum = column[3] + column[4] + column[5];
                        datas.push([column[0], column[1], column[2], sum, column[3], column[4] ]);
                    })
                    setExcelDatas(datas);
                } else {
                    setReports([]);
                    setExcelDatas([]);
                }
            })
        } else {
            setReports([]);
            setExcelDatas([]);
        }
    },[reportParams]);

    // 데이터를 넣을 빈배열
    const [checkedList, setCheckedList] = useState([]);
    // onChange함수를 사용하여 이벤트 감지, 필요한 값 받아오기
    const onCheckedElement = (checked, item) => {
        if (checked) {
            setCheckedList([...checkedList, item]);
        } else if (!checked) {
            setCheckedList(checkedList.filter(el => el !== item));
        }
    };

    const selectParam = (e) => {
        setReportParams(checkedList);
    };

    return (
        <div>
          <div className="report-dataroom">
              <div className="report-dataroom-left">
                <ul>
                  <li>{t('message.common.select.target.setting')}</li>
                  <li>
                      <FormGroup>
                      {equipmentCategoryLevel1s && equipmentCategoryLevel1s.map(function(level1, i) {
                        return (
                          <FormControlLabel key={i} value={level1.id} control={<Checkbox />} label={level1.name} onChange={e => {
                            onCheckedElement(e.target.checked, level1.id);
                          }}/>
                        )
                      })}
                      </FormGroup>
                  </li>
                </ul>
                <div style={{ textAlign:"center" }}>
                  <Button variant="contained" style={{margin:"3px"}} onClick={selectParam}>{t('message.common.btn.report.generation')}</Button>
                </div>
            </div>

            <div className='report-dataroom-right'>
              <p className="report-dataroom-tit">{t('menu.cmms.report-dataroom.status-report.equipment-status')}</p>
              <TableContainer>
                <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                    <colgroup>
                      <col width="*" />
                      <col width="*" />
                      <col width="*" />
                      <col width="150px" />
                      <col width="100px" />
                      <col width="100px" />
                    </colgroup>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t('message.common.subtitle.main.category')}</TableCell>
                      <TableCell>{t('message.common.subtitle.level2')}</TableCell>
                      <TableCell>{t('message.common.subtitle.level3')}</TableCell>
                      <TableCell>{t('message.common.subtitle.total.count')}</TableCell>
                      <TableCell>{t('message.common.subtitle.one.subwayline')}</TableCell>
                      <TableCell>{t('message.common.subtitle.two.subwayline')}</TableCell>
                    </TableRow>
                  </TableHead>
                  {reports && reports.length > 0 && 
                  <TableBody>
                  { reports && reports.map(function(item, i) {
                    let sum = item[3] + item[4];
                    return(
                    <TableRow key={i}>
                      <TableCell className='cont_left'>{item[0]}</TableCell>
                      <TableCell className='cont_left'>{item[1]}</TableCell>
                      <TableCell className='cont_left'>{item[2]}</TableCell>
                      <TableCell>{sum}</TableCell>
                      <TableCell>{item[3]}</TableCell>
                      <TableCell>{item[4]}</TableCell>
                    </TableRow>
                    )
                  }) }
                  </TableBody>
                  }
                </Table>
              </TableContainer>
              
              {(excelDatas && excelDatas.length > 0) ?
              <div className="report-dataroom-button">
                  <div></div>
                  <div className='no-print-page'>
                    <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelHeaders} title={t('menu.cmms.report-dataroom.status-report.equipment-status')} filename={`${fileName}.xlsx`} />
                  </div>
              </div>
              :
              (reports && reports.length > 0) ?
              <div className="report-dataroom-button">
                  <div></div>
                  <div className='no-print-page' style={{color:"#000"}}>
                      <Box sx={{ display: 'flex', color:"#000" }}>
                          {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                      </Box>
                  </div>
              </div>
              : ''
              }
            </div>
          </div>

        </div>
    )

}

export default EquipmentStatusReportDataroomStatusReport;